<template>
  <div>
    <link-button class="p-0" @click="openModal">
      {{ i18n.t('public.contact.button') }}
    </link-button>

    <contact-message-modal ref="modal" :create-path="contactPath" :current-user="currentUser"
                           :title="i18n.t('public.groups.contact_organiser', {count: organiserCount})"
                           :data-processing-consent="dataProcessingConsent" />
  </div>
</template>

<script>
import ContactMessageModal from '@/components/contact-message-modal'
import LinkButton from '@/components/buttons/link-button'

export default {
  components: { ContactMessageModal, LinkButton },

  props: {
    contactPath: {
      type: String,
      required: false
    },
    currentUser: {
      type: Object,
      required: false
    },
    dataProcessingConsent: {
      type: Object,
      required: true
    },
    organiserCount: {
      type: Number,
      required: true
    }
  },

  methods: {
    openModal() {
      this.$refs.modal.open()
    }
  }
}
</script>
